import axios from 'axios';
import BaseApi from 'services/api/base-api';
import numeral from 'numeral';

class GeneralContractorsApi extends BaseApi {
  getGeneralContractor(generalContractorId) {
    return axios
      .get(`${this.baseUrl}/general_contractors/${generalContractorId}`)
      .then((response) => {
        return {
          ok: true,
          generalContractor: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  getGeneralContractors(page, status, name) {
    let query = `page=${page || 1}`;
    query += status ? `&${status}=true` : '';
    query += name ? `&by_name=${name}` : '';
    return axios
      .get(`${this.baseUrl}/general_contractors?${query}`)
      .then((response) => {
        return {
          ok: true,
          generalContractors: {
            data: response.data,
            totalActive: numeral(response.headers['total-active']).value(),
            totalInactive: numeral(response.headers['total-inactive']).value(),
            total: numeral(response.headers['total']).value(),
            pageSize: numeral(response.headers['per-page']).value(),
          },
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  createGeneralContractor(values) {
    const data = {
      general_contractor: {
        name: values.name,
        contact_attributes: {
          first_name: values.firstName,
          last_name: values.lastName,
          email: values.email,
          phone_number: values.phoneNumber,
        },
        location_attributes: {
          street_address_1: values.streetAddress,
          street_address_2: values.unitNumber,
          city: values.city,
          state: values.state,
          zip: values.zipCode,
        },
      },
    };

    return axios
      .post(`${this.baseUrl}/general_contractors`, data)
      .then((response) => {
        return {
          ok: true,
          generalContractor: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  updateGeneralContractor(id, generalContractorData) {
    const headers = { headers: { 'Content-Type': 'multipart/form-data' } };
    return axios
      .put(
        `${this.baseUrl}/general_contractors/${id}`,
        generalContractorData,
        headers
      )
      .then((response) => {
        return {
          ok: true,
          generalContractor: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  updateGeneralContractorOnboardingData(onboardingData) {
    let data = new FormData();
    data.append(
      'general_contractor[license_number]',
      onboardingData.licenceNumber
    );
    data.append('general_contractor[confirmed]', onboardingData.confirmed);
    data.append(
      'general_contractor[logo_attributes][image]',
      onboardingData.companyLogo.image
    );

    return this.updateGeneralContractor(
      onboardingData.generalContractor.id,
      data
    );
  }

  updateGeneralContractorTeam(generalContractor) {
    let data = new FormData();
    data.append('general_contractor[name]', generalContractor.name);
    data.append(
      'general_contractor[license_number]',
      generalContractor.licenceNumber
    );
    data.append(
      'general_contractor[contact_attributes][first_name]',
      generalContractor.firstName
    );
    data.append(
      'general_contractor[contact_attributes][last_name]',
      generalContractor.lastName
    );
    data.append(
      'general_contractor[contact_attributes][email]',
      generalContractor.email
    );
    data.append(
      'general_contractor[contact_attributes][phone_number]',
      generalContractor.phoneNumber
    );
    data.append(
      'general_contractor[location_attributes][street_address_1]',
      generalContractor.streetAddress
    );
    data.append(
      'general_contractor[location_attributes][street_address_2]',
      generalContractor.unitNumber
    );
    data.append(
      'general_contractor[location_attributes][city]',
      generalContractor.city
    );
    data.append(
      'general_contractor[location_attributes][state]',
      generalContractor.state
    );
    data.append(
      'general_contractor[location_attributes][zip]',
      generalContractor.zipCode
    );
    data.append('general_contractor[confirmed]', true);
    const imageLogo = generalContractor.companyLogo.image;
    if (imageLogo && imageLogo.name && imageLogo.preview) {
      data.append('general_contractor[logo_attributes][image]', imageLogo);
    }

    return this.updateGeneralContractor(generalContractor.id, data);
  }

  getGeneralContractorProjects(generalContractorId, page, status) {
    return axios
      .get(
        `${
          this.baseUrl
        }/general_contractors/${generalContractorId}/projects?page=${
          page !== undefined ? page : 1
        }${status ? `&${status}=true` : ''}`
      )
      .then((response) => {
        return {
          ok: true,
          projects: {
            content: response.data,
            total: numeral(response.headers['total']).value(),
            totalPending: numeral(response.headers['total-pending']).value(),
            totalInProgress: numeral(
              response.headers['total-in_progress']
            ).value(),
            totalComplete: numeral(response.headers['total-complete']).value(),
            pageSize: numeral(response.headers['per-page']).value(),
          },
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  getUsers(generalContractorId) {
    return axios
      .get(`${this.baseUrl}/general_contractors/${generalContractorId}/users`)
      .then((response) => {
        return {
          ok: true,
          users: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const generalContractorsApi = new GeneralContractorsApi();



// WEBPACK FOOTER //
// ./src/services/api/general-contractors-api.js